export const updateBreadcrumbTitle = (productTitle, lastBreadcrumb) => {
  if (!lastBreadcrumb) {
    lastBreadcrumb = document.querySelector('.cmp-breadcrumbs li:last-child span');
  }

  if (lastBreadcrumb && productTitle) {
    lastBreadcrumb.textContent = productTitle;
  }
};
